export default "__VITE_ASSET__C7e_xFnu__"